import {
  Box,
  Container,
  CssBaseline,
  Toolbar,
  Typography,
} from "@mui/material";
import React, { useEffect, useState } from "react";
import Layout from "../../layout/Layout";
import { routeModules } from "../../../src/config/routeconfig";
import Loading from "../../common/Laoding";
import Bookingdashboard from "./Bookingdashboard";

const navItems = routeModules?.bookings?.sidebar;

const Bookingmodule = () => {
  const [activeItem, setActiveItem] = useState(navItems[0]?.label || "");
  const [isLoading, setIsLoading] = useState(true);

  const renderContent = () => {
    switch (activeItem) {
      case "Booking Dashboard":
        return <Bookingdashboard />;
      default:
        return <Typography>Need Access</Typography>;
    }
  };

  useEffect(() => {
    const timer = setTimeout(() => {
      setIsLoading(false); // Stop loading after 2 seconds
    }, 3000);

    return () => clearTimeout(timer);
  }, []);

  if (isLoading) {
    return <Loading />;
  }
  return (
    <div>
      <Box sx={{ display: "flex" }}>
        <CssBaseline />
        <Layout
          module={"bookings"}
          activeItem={activeItem}
          setActiveItem={setActiveItem}
        />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            backgroundImage: "linear-gradient(to top, #ffffff, #d4dfed)",
            // p: 3,
          }}
        >
          <Toolbar />
          <Container
            maxWidth={false}
            sx={{
              height: "100vh",
              overflowY: "scroll",
              scrollbarWidth: "none", // Firefox
              "&::-webkit-scrollbar": {
                display: "none", // Chrome, Safari
              },
            }}
          >
            {renderContent()}
          </Container>
        </Box>
      </Box>
    </div>
  );
};

export default Bookingmodule;
